module.exports = __webpack_public_path__ + "static/media/MileMarkerBrunch.bfdfd782.pdf";